usersModule.factory('usersSearchService',
    ['$q', 'AppSettings', 'userAuthenticateService', 'commonRESTCallService', 'User',
    function ($q, AppSettings, userAuthenticateService, commonRESTCallService, User) {
        var usersAPI = {};
        var myURL = AppSettings.startIdentitySvcURL + 'useraccounts/filters';
        var myToken = '';

        //get all users (paged), with filtering
        usersAPI.searchUsers = function (pageNum, pageSize, sortby, sortdirection, filters) {
            var promiseWrapper = $q.defer();
    
            var urlGet = myURL;

            urlGet = urlGet + '/?pagenum=' + pageNum + '&pagesize=' + pageSize + '&act=includeall';
            if (sortby)
                urlGet = urlGet + '&sort=' + sortby + '&ordermode=' + sortdirection;
            if (filters.firstName)
                urlGet = urlGet + '&firstname=' + filters.firstName;
            if (filters.lastName)
                urlGet = urlGet + '&lastname=' + filters.lastName;
            if (filters.loginID)
                urlGet = urlGet + '&loginid=' + filters.loginID;

            myToken = userAuthenticateService.getUserToken();

            commonRESTCallService.getFromServerWithToken(urlGet, myToken)
                .success(function(responseData, status) {
                    var users = responseData.ItemList.map(function(element) {
                        var user = new User();
                        user.populateDataFromIdentityManagement(element);
                        return user;
                    });
                    promiseWrapper.resolve(users);
                }).error(function(responseData, status) {
                    promiseWrapper.reject(responseData);
                });

            return promiseWrapper.promise;
        };

        usersAPI.retrieveCurrentUser = function() {
            var promiseWrapper = $q.defer();
            // imUserId will normally be the same as the logged in user, but need not be
            myToken = userAuthenticateService.getUserToken();
            var imUserId = userAuthenticateService.getUserId();
            var retrieveUserUrl = AppSettings.startIdentitySvcURL + 'useraccounts/' + imUserId;

            commonRESTCallService.getFromServerWithToken(retrieveUserUrl, myToken)
                .success(function(responseData, status){
                    promiseWrapper.resolve(responseData);
                }).error(function(responseData, status){
                    promiseWrapper.reject(responseData);
                });
            return promiseWrapper.promise;
        };

        return usersAPI;
    }
]);